import styled from 'styled-components';

export const Navigation = styled.div`
  display: flex;
  align-items: center;
  height: 70px;
  padding: 0 24px;
`;